import { create } from 'zustand';

export interface PlatformAdmin {
  id: string;
  username: string;
  phone?: string;
  email?: string;
  nickname?: string;
  department?: string;
  /** RBAC 角色（后端登录返回 role_code/role_name，不再返回旧的 role 字段）。super_admin = 全权限。 */
  role_id?: string;
  role_code?: string;
  role_name?: string;
}

interface State {
  jwt: string | null;
  user: PlatformAdmin | null;
  permissions: string[];
  setAuth: (jwt: string, user: PlatformAdmin, permissions: string[]) => void;
  logout: () => void;
  hasPermission: (perm: string) => boolean;
}

const STORAGE_KEY = 'platform_jwt';

export const usePlatformAuth = create<State>((set, get) => ({
  jwt: localStorage.getItem(STORAGE_KEY),
  user: null,
  permissions: [],
  setAuth: (jwt, user, permissions) => {
    localStorage.setItem(STORAGE_KEY, jwt);
    set({ jwt, user, permissions });
  },
  logout: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ jwt: null, user: null, permissions: [] });
  },
  // '*' = super_admin 通配，拥有全部权限（与后端 hasPermission 短路判定一致）
  hasPermission: (p) => {
    const perms = get().permissions;
    return perms.includes('*') || perms.includes(p);
  },
}));
